<template>
  <div :class="['editor-detail-articles-skeleton', { _mobile: isMobile }]">
    <div class="editor-detail-articles-skeleton__title"></div>
    <ul class="editor-detail-articles-skeleton__list">
      <li v-for="index in 3" :key="index" class="editor-detail-articles-skeleton__item">
        <div class="editor-detail-articles-skeleton__image"></div>
        <div class="editor-detail-articles-skeleton__content">
          <div class="editor-detail-articles-skeleton__category"></div>
          <div class="editor-detail-articles-skeleton__name"></div>
          <div class="editor-detail-articles-skeleton__description"></div>
          <div class="editor-detail-articles-skeleton__info"></div>
        </div>
      </li>
    </ul>
    <div class="editor-detail-articles-skeleton__button"></div>
  </div>
</template>

<script setup lang="ts">
const isMobile: boolean = useIsMobile();
</script>

<style lang="less">
.editor-detail-articles-skeleton {
  .flex-column(@size-x10);

  &__title {
    .skeleton(280px, 39px);
  }

  &__list {
    .flex-column(@size-x6);
  }

  &__item {
    .box-shadow();

    display: flex;
    gap: @size-x10;
    align-items: flex-start;
    border-radius: @main-size;
  }

  &__image {
    .skeleton(185px, 154px);

    flex-shrink: 0;
  }

  &__content {
    .flex-column(@size-x3);

    flex: 1 1 auto;
    min-width: 0;
    padding: @size-x5 @size-x5 @size-x5 0;
  }

  &__category {
    .skeleton(30%, 18px);
  }

  &__name {
    .skeleton(90%, 21px);
  }

  &__description {
    .skeleton(100%, 21px);
  }

  &__info {
    .skeleton(40%, 18px);
  }

  &__button {
    .skeleton(230px, 48px);

    align-self: flex-start;
  }

  &._mobile &__title {
    width: 220px;
    height: 30px;
  }

  &._mobile &__item {
    flex-direction: column;
    gap: @size-x5;
  }

  &._mobile &__image {
    width: 100%;
    height: 160px;
  }

  &._mobile &__content {
    width: 100%;
    padding: 0 @size-x4 @size-x4 @size-x4;
  }

  &._mobile &__button {
    width: 100%;
  }
}
</style>
